import { SearchRounded } from '@mui/icons-material';
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { useEffect, useRef } from 'react';

type AutoCompleteTextFieldProps = TextFieldProps & {
  open?: boolean;
};

export function AutoCompleteTextField(props: AutoCompleteTextFieldProps) {
  const textFieldRef = useRef<HTMLInputElement>(null);
  const isAutocompleteOpen = props.open ?? false;

  useEffect(() => {
    if (textFieldRef.current && isAutocompleteOpen) {
      textFieldRef.current.focus();
    }
  }, [isAutocompleteOpen]);

  return (
    <TextField
      autoFocus
      sx={{ pt: 0.75, ...props.sx }}
      inputRef={textFieldRef}
      placeholder="Choose an option"
      autoComplete="off"
      autoCapitalize="none"
      spellCheck="false"
      {...props}
      variant={props.variant ?? 'standard'}
      InputProps={{
        ...props.InputProps,
        startAdornment: (
          <InputAdornment position="start" sx={{ pl: 1.5 }}>
            <SearchRounded />
          </InputAdornment>
        ),
      }}
    />
  );
}
